<template>
  <div class="message-container">
    <div class="message-wrapper disp-scroll">
      <!-- タイトル -->
      <p class="-title">
        <b>履歴書フォームの設定をしてください</b>
      </p>
      <!-- 証明写真の必須設定 -->
      <p style="text-align: left; font-weight: 600">必須設定</p>
      <div class="message">
        <p style="margin-bottom: 8px">必須入力　※OFFにすると任意項目になります</p>
        <b-switch v-model="scenarioEdit.parameter.image_required" :disabled="scenarioEdit.is_confirm">証明写真</b-switch>
      </div>
      <!-- PDF作成設定 -->
      <p style="text-align: left; font-weight: 600">PDF出力</p>
      <div>
        <b-switch v-model="scenarioEdit.parameter.is_make_pdf" :disabled="scenarioEdit.is_confirm">履歴書をPDFに出力する</b-switch>
      </div>
      <!-- 出力先の選択 -->
      <div class="message" v-if="scenarioEdit.parameter.is_make_pdf">
        <p style="text-align: left; font-weight: 600; padding-top: 16px">
          出力先を選択(複数選択可)
        </p>
        <!-- 応募者管のダウンロード可/不可 -->
        <div style="padding: 8px">
          <b-field>
            <div class="message">
              <b-switch v-model="scenarioEdit.parameter.enable_download" :disabled="scenarioEdit.is_confirm"
                >応募者の履歴書ダウンロードを許可</b-switch
              >
            </div>
          </b-field>
        </div>
        <!-- 応募者管理画面に出力 -->
        <div style="padding: 8px">
          <b-field>
            <div class="message">
              <b-switch v-model="scenarioEdit.parameter.applicant_manage" :disabled="scenarioEdit.is_confirm"
                >応募者管理画面に出力</b-switch
              >
            </div>
          </b-field>
        </div>
        <!-- メールで送信 -->
        <div style="padding: 8px">
          <b-switch v-model="scenarioEdit.parameter.send_mail" :disabled="scenarioEdit.is_confirm">メールに添付して出力</b-switch>
          <b-field v-if="scenarioEdit.parameter.send_mail === true">
            <b-input
              style="width: 80%"
              placeholder="例：abc@xyz.com"
              v-model="scenarioEdit.parameter.mail_to"
              max-length="254"
              :disabled="scenarioEdit.is_confirm"
            />
            <div style="margin: 4px">へ送信</div>
          </b-field>
        </div>
        <!-- Googleドライブに保存 -->
        <div style="padding: 8px">
          <b-switch v-model="scenarioEdit.parameter.save_google_drive" v-if="isGoogleDriveAuth" :disabled="scenarioEdit.is_confirm"
            >Googleドライブに保存</b-switch
          >
          <div
            class="message"
            v-if="!isSettingUser && scenarioEdit.parameter.save_google_drive === true"
          >
            <p style="text-align: left">※別のユーザーがGoogleDrive設定済みです。</p>
            <p style="text-align: left">　変更する際はご注意ください。</p>
          </div>
          <!-- 保存方法の選択 -->
          <div v-if="scenarioEdit.parameter.save_google_drive === true && isGoogleDriveAuth">
            <p style="text-align: left; font-weight: 600; padding-top: 16px">保存方法を選択</p>
            <b-field>
              <b-switch
                style="width: 100%"
                size="is-small"
                v-model="scenarioEdit.parameter.preserve"
                :disabled="scenarioEdit.is_confirm"
              >
                {{ preserve() }}
              </b-switch>
            </b-field>
            <!-- 保存先の選択 -->
            <p style="text-align: left; font-weight: 600; padding-top: 16px">保存先を選択</p>
            <!-- GoogleFriveフォルダ一覧 -->
            <div v-if="!scenarioEdit.parameter.drive_info || !isSettingUser">
              <!-- GoogleDrive保存情報なし -->
              <!-- または前回保存ユーザーと異なる時 -->
              <GoogleDriveFolderList
                style="width: 100%; padding: 16px"
                :userId="userId"
                :isConfirm="scenarioEdit.is_confirm"
                @set-folder="setFolder"
              />
            </div>
            <div v-else>
              <!-- GoogleDrive保存情報あり -->
              <GoogleDriveFolderList
                style="width: 100%; padding: 16px"
                :userId="userId"
                :folderId="scenarioEdit.parameter.drive_info.id"
                :folderName="scenarioEdit.parameter.drive_info.name"
                :mimeType="scenarioEdit.parameter.drive_info.mime_type"
                :folderPath="scenarioEdit.parameter.drive_info.folderPath"
                :isConfirm="scenarioEdit.is_confirm"
                @set-folder="setFolder"
              />
            </div>
            <!-- 出力ファイル名の入力 -->
            <p style="text-align: left; font-weight: 600">出力ファイル名を入力</p>
            <b-field>
              <input
                style="width: 40%; is-small"
                placeholder="例：履歴書"
                v-model="scenarioEdit.parameter.file_name"
                :disabled="scenarioEdit.is_confirm"
              />
              <div style="margin: 4px">_＜応募者名＞</div>
            </b-field>
          </div>
        </div>
      </div>
      <!-- GoogleDrive非連携時の注釈 -->
      <div style="text-align: left" v-if="!isGoogleDriveAuth">
        <p style="text-align: left; padding-top: 16px; margin-bottom:16px;">
          ※現在このアカウントはGoogleDrive連携がされていません。 連携を行う場合は「設定」>
          「外部連携」 > 「GoogleDrive連携」より連携をお願いいたします。
        </p>
      </div>
      <!-- 生年月日の初期設定 -->
      <p style="text-align: left; font-weight: 600">生年月日の初期値</p>
      <div>
        <section class="section-3">
          <b-datepicker
            locale="ja-JP"
            v-model="defaultBirth"
            @input="changedefaultBirth(defaultBirth)"
            :focused-date="defaultBirth"
            :mobile-native="false"
            placeholder="生年月日の初期値を設定"
            :open-on-focus="true"
            icon="calendar-today"
          >
          </b-datepicker>  
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleDriveFolderList from '@/components/organisms/common/GoogleDriveFolderList'

export default {
  components: {
    /** GoogleDrive一覧 */
    GoogleDriveFolderList,
  },
  props: {
    /** シナリオデータ */
    scenarioEdit: {
      type: Object,
      required: false,
    },
    /** GoogleDrive連携可否 */
    isGoogleDriveAuth: {
      type: Boolean,
      required: false,
      default: false,
    },
    /** GoogleDrive連携ユーザーID */
    userId: {
      type: String,
      required: false,
      default: '',
    },
  },
  data () {
    return {
      defaultBirth: null
    }
  },
  computed: {
    isSettingUser() {
      let result = false
      if (!this.scenarioEdit.parameter.user_uuid) {
        // 未設定
        result = true
      } else if (this.scenarioEdit.parameter.user_uuid === this.userId) {
        // 同一ユーザー設定済み
        result = true
      } else {
        // 他ユーザー設定済み
        result = false
      }
      return result
    },
  },
  mounted() {
    if (!this.scenarioEdit.parameter['default_birth']) {
      this.defaultBirth = new Date()
    } else {
      this.defaultBirth = new Date(this.scenarioEdit.parameter['default_birth'])
    }
    if (
      this.scenarioEdit.parameter.user_uuid &&
      this.scenarioEdit.parameter.user_uuid !== this.userId
    ) {
      // 前回設定したユーザーと異なる場合は、一度GoogleDrive情報をクリアする
      this.scenarioEdit.parameter.drive_info = {
        id: '',
        name: '',
        mime_type: '',
        folderPath: [],
      }
    }
  },
  methods: {
    /** 選択フォルダ保存 */
    setFolder(folderId, folderName, mimeType, folderPath) {
      // ユーザーID保存
      this.scenarioEdit.parameter.user_uuid = this.userId
      // Googleドライブ用保存情報追加
      this.scenarioEdit.parameter.drive_info = {}
      // フォルダID保存
      this.scenarioEdit.parameter.drive_info.id = folderId
      // フォルダ名保存
      this.scenarioEdit.parameter.drive_info.name = folderName
      // MIMEタイプ保存
      this.scenarioEdit.parameter.drive_info.mime_type = mimeType
      // フォルダパス保存
      this.scenarioEdit.parameter.drive_info.folderPath = folderPath
    },
    /** 保存方法 */
    preserve() {
      const dispPreserve = this.scenarioEdit.parameter.preserve ? '上書き保存' : '新規作成'
      return dispPreserve
    },
    changedefaultBirth (defaultBirth) {
      console.log('parameter: ', this.scenarioEdit.parameter)
      this.scenarioEdit.parameter['default_birth'] = defaultBirth
    }
  },
}
</script>

<style lang="scss" scoped>
.message-container {
  .message-wrapper {
    height: 500px;
    background-color: white;
    .-title {
      font-size: 16px;
      padding: 16px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/chatbot/modals/ModalResumeParts.vue